import { BetBuilderPickResponse } from "@api-types/bet-booster/BetBuilderPickResponse";
import { GenericResponse } from "@api-types/common";
import { httpClient } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData } from "@utils/api-config/types";

export class BetBuilderApiService {
	static get baseUrl() {
		return `${WEBPACK_BET_BOOSTER_API_ADDRESS}/bet-builder`;
	}
	static getRequestHeaders(context: ApiRequestContextData) {
		const appHeaders = getApplicationRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	}

	static getEventBetBuilderPicksAvailability(
		eventId: string
	): Promise<GenericResponse<BetBuilderPickResponse[]>> {
		const context = getApiRequestContext();

		return httpClient.get(
			`${this.baseUrl}/presets/event/${eventId}`,
			this.getRequestHeaders(context)
		);
	}

	static getBetBuilderPicksAvailability(): Promise<
		GenericResponse<BetBuilderPickResponse[]>
	> {
		const context = getApiRequestContext();

		return httpClient.get(
			`${this.baseUrl}/presets`,
			this.getRequestHeaders(context)
		);
	}
}
